import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=7d019941&"
import script from "./PhotoModal.vue?vue&type=script&lang=ts&"
export * from "./PhotoModal.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports